import React from "react";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { t } from "ttag";

import { templates } from "@reactivated";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

export const Template = (
    props: templates.CheckoutHeaderTemplate,
): React.ReactNode => {
    const secureCheckout = richT(t`<secure>secure</secure> checkout`, {
        secure: (children) => (
            <span className="checkout-header__header--bold">{children}</span>
        ),
    });
    return (
        <header className="header checkout-header">
            <a className="site-nav__logo-link" href={props.root_page_url}>
                <svg
                    className="desktop-only"
                    role="img"
                    aria-labelledby="desktop-only-logo"
                >
                    <title id="desktop-only-logo">{t`Sealy Homepage`}</title>
                    <use xlinkHref="#bowtie" />
                </svg>
            </a>

            <a
                className="site-nav__logo-link site-nav__logo-link--mobile"
                href={props.root_page_url}
            >
                <svg
                    className="mobile-only"
                    role="img"
                    aria-labelledby="mobile-only-logo"
                >
                    <title id="mobile-only-logo">{t`Sealy Homepage`}</title>
                    <use xlinkHref="#wordmark" />
                </svg>
            </a>

            <h1 className="checkout-header__header">{secureCheckout}</h1>

            <div className="checkout-header__header-cart-ref">
                <CartReferenceNumber
                    encodedBasketID={props.encoded_basket_id}
                    phoneNumber={props.support_website_phone_number}
                />
            </div>
        </header>
    );
};
